import http from "../http";

export async function getReports(config) {
  const response = await http.get("/workflow-report/v2", config);
  return response.data;
}

export async function getHistory(config) {
  const response = await http.get("/workflow-report-history/v3", config);
  return response.data;
}

export async function exportReports(config) {
  const response = await http.get("/workflow-report-export/v2", config);
  return response.data;
}
